import React from 'react';

/**
 * Reusable Ad Banner component for monetization
 * @param {string} placement - Banner placement identifier (e.g., 'homepage_top', 'predictions_progress', 'sidebar')
 * @param {string} size - Banner size: 'large', 'medium', 'small'
 */
const AdBanner = ({ placement = 'default', size = 'medium' }) => {
  const sizeClasses = {
    large: 'h-32 md:h-40',
    medium: 'h-24 md:h-32',
    small: 'h-16 md:h-20'
  };

  const sizeText = {
    large: '970x250',
    medium: '728x90',
    small: '468x60'
  };

  return (
    <div 
      className={`w-full ${sizeClasses[size]} bg-gradient-to-r from-yellow-600/10 via-yellow-500/10 to-amber-600/10 border border-yellow-600/20 rounded-lg flex items-center justify-center backdrop-blur-sm`}
      data-ad-placement={placement}
    >
      <div className="text-center space-y-1">
        <div className="text-yellow-500/60 text-sm font-medium">
          Advertisement
        </div>
        <div className="text-yellow-500/40 text-xs">
          {sizeText[size]} · {placement}
        </div>
        <div className="text-yellow-500/30 text-xs italic">
          Ad space available
        </div>
      </div>
    </div>
  );
};

export default AdBanner;